import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Signal } from '@angular/core';
import { ButtonModule, SelectModule, InputModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManagerReviewForm, ManagerReviewFormGroup } from '../../../models/cod-review.model';
import { CodReviewOperations } from '../../../operations/cod-review.operations';
import { CodReviewState } from '../../../state/cod-review.state';
import { select, Store } from '@ngxs/store';
import { SubmitManagerReview } from '../../../state/cod-review.action';
import { ReviewResult, BasicReviewResult, ReviewNextStepClose } from '@cod-monorepo/interfaces';
import { CodReviewSuccessComponent } from '../review-success/review-success.component';
import { NgxsFormDirective } from '@ngxs/form-plugin';

@Component({
    selector: 'app-cod-manager-review-step',
    templateUrl: './manager-review.component.html',
    imports: [
        CommonModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        InputModule,
        ButtonModule,
        TextareaModule,
        CodReviewSuccessComponent,
        NgxsFormDirective
    ],
    standalone: true
})
export class CodManagerReviewStepComponent implements OnInit, OnChanges {
    @Input() disabled: boolean;

    protected submitting: Signal<boolean> = select(CodReviewState.submittingManagerReview);
    protected submittingSuccess: Signal<boolean> = select(CodReviewState.submittingManagerReviewSuccess);
    public formGroup: FormGroup<ManagerReviewFormGroup>;
    public basicReviewResult = BasicReviewResult;
    public reviewResult = ReviewResult;
    public nextSteps = ReviewNextStepClose;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.formGroup = CodReviewOperations.initializeManagerReviewForm();

        if (this.disabled) {
            this.formGroup.disable();
        }
    }

    public ngOnChanges(): void {
        if (this.disabled) {
            this.formGroup && this.formGroup.disable();
        } else {
            this.formGroup && this.formGroup.enable();
        }
    }

    public submit(): void {
        if (this.formGroup.invalid) {
            return;
        }

        this.store.dispatch(new SubmitManagerReview(this.formGroup.value as ManagerReviewForm));
        this.formGroup.disable();
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }
}
